import DLabGrid from "../../components/DLabGrid/DLabGrid";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  BookingMetaByEquipment,
  DEFAULT_FILTER,
} from "../../constants";
import {
  buildProjectsLabel,
  filterParams,
  getWeekStartAndEndInISOString,
  replaceOffsetWithOther,
  valueOrEmpty,
} from "../../utils/helpers/text/index";
import { PaginationContext } from "../../components/shared/pagination/PaginationContext";
import { getAllData } from "../../utils/helpers/fetching";
import {
  GET_BOOKING_DATA_BY_SITE,
} from "../../gql/bookingapi";
import { compose, withApollo } from "react-apollo";
import { connect, useSelector } from "react-redux";
import { loadPendingReservations as loadPendingReservationsAction } from "../booking-calendars/redux/actions";
import BookingMenuAction from "./BookingMenuAction";
import BackdropPortal from "../../components/shared/BackdropPortal";
import moment from "moment";
import { BookingContext } from "../booking/context";
import CheckInButton from "../../components/shared/CheckInButton/CheckInButton";
import { EN_DASH } from "@digitallab/grid-common-components";
import { BookingTypeChip } from "../../components/shared/BookingTypeChip";
import { BookingHazardousChip } from "../../components/shared/BookingHazardousChip";
import useInstrumentCache from "../../utils/hooks/useInstrumentCache";
import { useSharedFilterState } from "./SharedFilterContext";
import SaveConfiguration from "../../components/EquipmentList/Components/SaveConfiguration";
import {
  onAgGridFilterApply
} from "../../components/EquipmentList/Service/filterService";
import {
  convertStrToObjFilters,
} from "../../components/EquipmentList/Service/equipmentService";
import { onAgGridColumnApply } from "../../components/EquipmentList/Service/columnService";
import { getBookingDisplayText } from "../../components/shared/helpFunctions";
import { TOOL_PANELS, filterKeyMapping } from "../../components/EquipmentList/Constants/constants";
import { useBooking } from "../../components/EquipmentList/Service/commonsService";
import { hazardousStatusGetter } from "../../utils/helpers/data";
import {
  createDefaultCsvExportParams,
  createDefaultExcelExportParams,
  createClipboardCellProcessor,
  getExportableColumnKeys,
} from "../../utils/helpers/exportValueMapper";
import BookingsPaginationActions from "../../components/shared/BookingsPaginationActions";
import ProjectRenderer from "../equipment-list/ProjectRender";
import { DateWithRecurrenceCellRenderer } from "../../utils/helpers/text/DateWithRecurrenceCellRenderer";

const EquipmentBookingList = ({
  client,
  resetAll,
  searchQuery,
  setSearchQuery,
  setSelectedDateRange,
  setDisableResetAll,
  defaultShowColumns = [],
  selectedDateRange,
  setIsDropBooking,
  setIsDialogOpen,
  selectedEquipment,
  setSelectedEquipment,
  setOpenMultiDeleteDialog,
  setEnableResetAll,
  setRowEquipmentId,
  tempRowData,
  setTempRowData,
  loadPendingReservations,
  setPopupEnableStatus,
  showAdvanceFilter,
  savedFilter,
  signeeFilter,
  setDisplayPreset,
  displayPreset,
  userFilters,
  userDisplayColumnMaster,
  setUserFilters,
  setUserDisplayColumnMaster,
  setSavedFilter,
  myLabFilter,
  showSideBar,
  dataModel,
  localUserFilters,
  currentSideBarPanel,
  setCurrentSideBarPanel,
  setLastDisplayColumns,
  setLastFavFilter,
  shouldFetchData
}) => {
  const { nextToken, data, fetching, dispatchAction } = useContext(PaginationContext);
  const { dispatchAction: bookingDispatchAction } = useContext(BookingContext);
  const user = useSelector((store) => store.user);
  // const usersList = useSelector((state) => state.users.users);
  const [gridApi, setGridApi] = useState(null);
  const rowStyle = { background: "var(--one-color-cobas-accent-gray-100)" };

  const gridRef = useRef();
  const abortRef = useRef(null);
  const debouncedFetchRef = useRef(null);
  const lastDateKeyRef = useRef(null);

  const {
    filterState,
    isFilterDataReady,
    loadFilterData,
    updateCurrentFilter,
  } = useSharedFilterState();

  const filterDefToNameMap = useMemo(() => {
    const map = new Map();
    (userFilters || []).forEach(f => {
      const key = JSON.stringify(f?.filterDefinition || {});
      map.set(key, f?.filterName || f?.chipName || "Unnamed");
    });

    if (myLabFilter?.filterDefinition) {
      map.set(JSON.stringify(myLabFilter.filterDefinition), myLabFilter.filterName || "My Lab");
    }

    return map; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userFilters, myLabFilter, filterState?.currentFilter]);

  useEffect(() => {
    if (!filterState?.currentFilter?.filterDefinition) return
    onAgGridFilterApply({
      gridRef,
      savedFilterModel: filterState?.currentFilter?.filterDefinition,
      filterKeyMapping,
    });
    setTimeout(() => onAgGridFilterApply({
      gridRef,
      savedFilterModel: filterState?.currentFilter?.filterDefinition,
      filterKeyMapping,
    }), 1000)
  }, [filterState?.currentFilter]);


  const onApplyFilterFromChip = useCallback(
    (savedFilterModel) => {
      if (savedFilterModel === undefined) return;

      const filterObj =
        savedFilterModel && typeof savedFilterModel === "string"
          ? JSON.parse(savedFilterModel)
          : savedFilterModel || DEFAULT_FILTER;

      const filterDefinitionObj = Object.keys(filterObj)?.includes("filterName")
        ? convertStrToObjFilters(savedFilterModel)?.filterDefinition
        : filterObj;
      onAgGridFilterApply({
        gridRef,
        savedFilterModel: filterDefinitionObj,
        filterKeyMapping,
      });

      const key = JSON.stringify(filterDefinitionObj);
      const matchedName =
        filterDefToNameMap.get(key) || "Custom";
      if (setSavedFilter && matchedName !== "Custom") {
        setSavedFilter(matchedName);
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [setCurrentSideBarPanel]
  );

  const onApplyColumnsFromChip = useCallback((chipObj) => {
    const savedShowcolumns = chipObj?.displayDefinition?.showColumns;
    onApplyColumns(savedShowcolumns);
    if (setDisplayPreset) {
      setDisplayPreset({
        definition: chipObj.displayDefinition,
        label: chipObj.chipName,
        name: chipObj.id,
        ...chipObj
      })
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setDisplayPreset]);

  const savedFilterChips = useMemo(() => {
    const base = (myLabFilter?.filterDefinition?.inventoryIds?.length > 0
      ? [myLabFilter, ...(userFilters || [])]
      : [...(userFilters || [])]
    ).map(f => ({
      ...f,
      chipName: f.chipName || f.filterName,
      filterName: f.filterName,
      filterDefinition: f.filterDefinition,
      userID: f.userID || user?.id,
    }));

    return base; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userFilters, myLabFilter, filterState?.currentFilter, user?.id]);

  const savedColumnChips = useMemo(() => {
    return (userDisplayColumnMaster || []).map(d => ({
      ...d,
      chipName: d.chipName || d.displayName,
      displayName: d.displayName,
      displayDefinition:
        typeof d.displayDefinition === "string"
          ? JSON.parse(d.displayDefinition)
          : d.displayDefinition,
      userID: d.userID || user?.id,
    }));
  }, [userDisplayColumnMaster, user?.id]);

  const instrumentCache = useInstrumentCache({
    client,
    user,
    masterDataFilters: filterState.masterDataFilters,
  });

  const locationGetter = (params) => {
    const data = params?.data;
    return data?.locationKey;
  };
  const statusGetter = (params) => {
    const data = params?.data;
    if (!data?.active) {
      return "Cancelled";
    }
    // Check if booking has hazardous materials and is pending approval
    const normalizedStatus = data?.approval?.status?.toString().toUpperCase();
    if (data?.hazardousDeclaration?.hasHazardousMaterials && normalizedStatus === "PENDING") {
      return "Pending";
    }
    return "Active";
  };
  const reservedForGetter = (params) => {
    const users = params?.data?.bookedUsers ?? [];
    if (!users.length) {
      return "-";
    }
    const name = users[0]?.givenName ?? null + users[0]?.familyName ?? null;
    const userName = users[0]?.name ?? null;
    if (!name && !userName) {
      return "-";
    }
    const combinedName = name + " (" + userName + ") ";
    const result = combinedName.length > 10 ? combinedName.substring(0, 10) + "... " : combinedName;
    const suffix = users.length - 1 > 0 ? ` +${users.length - 1}` : "";
    return result + suffix;
  };
  const reservedForFilterFormatterGetter = (params) => {
    const users = params?.data?.bookedUsers ?? [];
    if (!users.length) {
      return "-";
    }
    return params?.data?.bookedUsers.map((user) => {
      const name = user?.givenName ?? null + user?.familyName ?? null;
      const userName = user?.name ?? null;
      return name + " (" + userName + ") ";
    });
  };
  const projectGetter = (params) => {
    const row = params?.data || {};
    return buildProjectsLabel({
      rowRedPandaProjects: row.redPandaProjects,
      userRedPandaProjects: user?.redPandaProjects,
      projectId: row.project,
    });
  };
  const descriptionGetter = (params) => {
    return valueOrEmpty(params?.data?.description, false, "-");
  };

  const fetchData = useCallback(async () => {
    const dateKey = JSON.stringify(selectedDateRange);
    if (lastDateKeyRef.current === dateKey) {
      console.log('Should cancel call')
      //return;
    }// deduplikacja
    lastDateKeyRef.current = dateKey;

    dispatchAction({ type: "fetching", payload: true });

    let dateFrom, dateTo;
    if (selectedDateRange[0] instanceof Date) {
      const dateFromString = moment(selectedDateRange[0]).format();
      const dateToString = moment(selectedDateRange[1]).format();
      const offset = moment.tz(user.timezone).format("Z");
      dateFrom = moment(replaceOffsetWithOther(dateFromString, offset)).utc().format();
      dateTo = moment(replaceOffsetWithOther(dateToString, offset, true)).utc().format();
    } else {
      dateFrom = moment(selectedDateRange[0]).utc().format();
      dateTo = moment(selectedDateRange[1]).utc().format();
    }

    const bookingFilter = {
      and: [
        { active: { eq: true } },
        { and: [{ dateFrom: { le: dateTo } }, { dateTo: { ge: dateFrom } }] },
      ],
    };

    if (signeeFilter?.userId && signeeFilter.userId !== "null" && signeeFilter.userId !== "") {
      bookingFilter.and.push({ reservedForUsers: { contains: signeeFilter.userId } });
    }

    const { items: bookings } = await getAllData({
      client,
      query: GET_BOOKING_DATA_BY_SITE,
      dataPath: ["data", "getBookingDataBySite"],
      drillData: true,
      variables: {
        filter: JSON.stringify(bookingFilter),
        dateFrom: dateTo,
        site: user.site,
        limit: 1000,
        nextToken,
      },
      cache: true,
    });

    bookings.forEach(b => {   // use inventoryId for mapping, since shortId from bookedEquipments may be missing
      const bookedEquipments = [];
      (b.bookingEntries || []).forEach(entry => {
        if (!bookedEquipments.includes(entry.inventoryId)) {
          bookedEquipments.push(entry.inventoryId)
        }
      });
      b.bookedEquipments = bookedEquipments
    });

    const equipmentMap = {};
    bookings.forEach(b => {
      (b.bookedEquipments || []).forEach(id => {
        if (!equipmentMap[id]) {
          equipmentMap[id] = {
            inventoryId: id,
            bookings: [],
          };
        }
        equipmentMap[id].bookings.push(b);
      });
    });

    const ids = Object.keys(equipmentMap)
    if (ids.length) {
      abortRef.current?.abort();
      abortRef.current = new AbortController();
      const loadInstrumentsResponse = await instrumentCache.loadInstruments(
        user.site,
        filterState?.currentFilter?.filterDefinition || {},
        { signal: abortRef.current.signal }
      );
      if (!loadInstrumentsResponse) {
        dispatchAction({
          type: "fetching",
          payload: false,
        });
        return;
      }
      const { items: instruments } = loadInstrumentsResponse;
      instruments.forEach(inst => {
        const instrumentId = `${inst.inventoryId}`;
        equipmentMap[instrumentId] && Object.assign(equipmentMap[instrumentId], {
          instrumentId,
          ...inst
        });
      });
    }

    for (const key of Object.keys(equipmentMap)) {  // remove filtered instruments
      if (!equipmentMap[key]?.instrumentId) {
        delete equipmentMap[key];
      }
    }

    const equipmentRows = [];
    Object.values(equipmentMap).forEach(eq => {

      eq.bookings.forEach(b => {
        const status = (b.approval?.status ?? (b.active ? "ACTIVE" : "CANCELLED")) ?? eq.status
        equipmentRows.push({
          ...eq,
          ...b,
          uniqId: `${eq.inventoryId}_${b.id}`,
          id: b.id,
          dateFrom: b.dateFrom,
          dateTo: b.dateTo,
          type: b.type,
          approval: b?.approval,
          status,
          active: status === 'ACTIVE' || status === 'PENDING',
          bookingFor: (b.bookedUsers?.[0]?.givenName || "") + " " +
            (b.bookedUsers?.[0]?.familyName || ""),
          project: b.project,
          redPandaProjects: b.redPandaProjects,
          description: b.description,
          checkIn: b.checkInRequired,
        });
      });
    });
    dispatchAction({
      type: "nextToken",
      payload: { token: null, data: equipmentRows },
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, instrumentCache, selectedDateRange, user.site, user.timezone, filterState, signeeFilter]);


  useEffect(() => {
    if (!isFilterDataReady) {
      dispatchAction({
        type: "fetching",
        payload: true,
      });
      return
    }
    if (debouncedFetchRef.current) clearTimeout(debouncedFetchRef.current);
    debouncedFetchRef.current = setTimeout(fetchData, 400); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData, isFilterDataReady]);

  useEffect(() => {
    if (shouldFetchData) {
      fetchData()
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetchData]);

  useEffect(
    () => () => {
      abortRef.current?.abort();
      if (debouncedFetchRef.current)
        clearTimeout(debouncedFetchRef.current);
    },
    []
  );

  const {
    currentFilterChip,
    onApplyColumns,
    currentColumnsChip,
    dateFromFormatter,
    dateToFormatter,
    onSave,
    icons,
    onRowSelected,
    onChipDelete,
    editBooking,
  } = useBooking({
    filterState,
    displayPreset,
    defaultShowColumns,
    gridRef,
    onAgGridColumnApply,
    savedFilter,
    isFilterDataReady,
    updateCurrentFilter,
    loadFilterData,
    user,
    gridApi,
    searchQuery,
    client,
    localUserFilters,
    setUserFilters,
    setLastFavFilter,
    setUserDisplayColumnMaster,
    setLastDisplayColumns,
    userFilters,
    userDisplayColumnMaster,
    setSelectedEquipment,
    selectedEquipment,
    setDisplayPreset,
    setSavedFilter,
    dispatchAction,
    bookingDispatchAction,
    loadPendingReservations,
  });

  const actionRender = (params) => {
    return (
      <BookingMenuAction
        params={params}
        handlers={{ deleteEquipment, editBooking, setRowEquipmentId, setPopupEnableStatus }}
      />
    );
  };

  const overrideCellRender = (key, defaultObj) => {
    switch (key) {
      case "type":
        defaultObj = {
          ...defaultObj,
          filter: false,
          cellRenderer: (item) =>
            item?.data?.type ? <BookingTypeChip key={item.data.id} item={item.data} /> : EN_DASH,
          filterValueGetter: (params) => {
            return getBookingDisplayText(params?.data);
          },
          valueGetter: (params) => {
            return getBookingDisplayText(params?.data);
          },
        };
        break;
      case "checkIn":
        defaultObj = {
          ...defaultObj,
          cellRenderer: (item) =>
            item?.data?.checkInRequired ? <CheckInButton key={item.data.id} item={item.data} /> : null,
        };
        break;
      case "dateFrom":
        defaultObj = {
          ...defaultObj,
          checkboxSelection: true,
          showDisabledCheckboxes: true,
          filter: "agDateColumnFilter",
          filterParams,
          valueFormatter: dateFromFormatter,
          filterValueGetter: dateFromFormatter,
          cellRenderer: DateWithRecurrenceCellRenderer
        };
        break;
      case "dateTo":
        defaultObj = {
          ...defaultObj,
          filter: "agDateColumnFilter",
          filterParams,
          valueFormatter: dateToFormatter,
          filterValueGetter: dateToFormatter,
        };
        break;
      case "active":
        defaultObj = {
          ...defaultObj,
          valueGetter: statusGetter,
          filterValueGetter: statusGetter,
        };
        break;
      case "location":
        defaultObj = {
          ...defaultObj,
          valueGetter: locationGetter,
          filterValueGetter: locationGetter,
        };
        break;
      case "approval":
        defaultObj = {
          ...defaultObj,
          filter: true,
          valueGetter: statusGetter,
          cellRenderer: (item) =>
            <BookingHazardousChip key={item.data.id} item={item.data} />,
          filterValueGetter: statusGetter,
        };
        break;
      case "hazardous":
        defaultObj = {
          ...defaultObj,
          filter: true,
          cellRenderer: (item) => <BookingHazardousChip key={item.data.id} item={item.data} />,
          filterValueGetter: hazardousStatusGetter,
          valueGetter: hazardousStatusGetter,
        };
        break;

      case "reservedForUsers":
        defaultObj = {
          ...defaultObj,
          valueGetter: reservedForGetter,
          filterValueGetter: reservedForFilterFormatterGetter,
        };
        break;
      case "project":
        defaultObj = {
          ...defaultObj,
          filter: "agTextColumnFilter",
          filterParams: {
            filterOptions: ["contains"],
            defaultToNothingSelected: true,
            buttons: ["reset", "apply"],
          },
          cellRenderer: ProjectRenderer,
          filterValueGetter: projectGetter,
          cellStyle: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        };
        break;
      case "shouldAssisted":
        defaultObj = {
          ...defaultObj,
          cellClass: "action-render",
          filter: "agSetColumnFilter",
          filterParams: {
            defaultToNothingSelected: true,
            showTooltips: true,
            buttons: ["reset"],
            values: (params) => params.success(["Yes", "No"]),
          },
          filterValueGetter: (params) => params?.data?.shouldAssisted === '1' ? "Yes" : "No",
        };
        break;
      case "description":
        defaultObj = {
          ...defaultObj,
          filter: "agTextColumnFilter",
          filterParams: {
            filterOptions: ["contains"],
            defaultToNothingSelected: true,
            buttons: ["reset", "apply"],
          },
          valueGetter: descriptionGetter,
          filterValueGetter: descriptionGetter,
        };
        break;
      case "actionButton":
        defaultObj = {
          ...defaultObj,
          width: 0,
          maxWidth: 50,
          field: "actions",
          headerName: "Actions",
          filter: false,
          pinned: "right",
          lockVisible: true,
          lockPosition: "right",
          cellClass: "action-render",
          cellRenderer: actionRender,
        };

        break;

      case "detailExpander":
        defaultObj = {
          ...defaultObj,
          cellRenderer: "agGroupCellRenderer",
          pinned: "left",
        };

        break;

      default:
        defaultObj = {
          ...defaultObj,
          valueGetter: (params) => valueOrEmpty(params?.data[key] ?? "-", false, "-"),
          filterValueGetter: (params) => valueOrEmpty(params?.data[key] ?? "-", false),
        };
        break;
    }
    return defaultObj;
  };

  const tableColumn = useMemo(() => {
    const dataModelFull = [...Object.entries(BookingMetaByEquipment.fields).map(
      ([key, meta]) => ({ key, meta })
    ),
    ...dataModel.map(
      col => ({ key: col.key, meta: col })
    )];
    const baseMap = dataModelFull.reduce((acc, { key, meta }) => {
      acc[key] = overrideCellRender(key, {
        headerName: meta.val ?? meta.text,
        field: key,
        sortable: meta.sortable ?? true,
        floatingFilter: showAdvanceFilter,
        filter: meta.filter ?? true,
        filterParams: meta.filterParams,
        resizable: true,
        headerTooltip: meta.val ?? meta.text,
        width: meta.width || 200,
        maxWidth: meta.maxWidth || 200,
        minWidth: meta.minWidth || 200,
        ...meta
      });

      return acc;
    }, {});

    return Object.values(baseMap) // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [BookingMetaByEquipment.fields, dataModel]);



  const onGridReady = useCallback((params) => {
    setGridApi(params);
  }, []);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      resizable: true,
      suppressMenu: true,
      sortable: true,
    };
  }, []);

  useEffect(() => {
    if (gridApi && resetAll) {
      gridRef.current.api.setFilterModel();
      setSearchQuery("");
      setSelectedEquipment([]);
      setSelectedDateRange([
        getWeekStartAndEndInISOString("start", user.timezone),
        getWeekStartAndEndInISOString("end", user.timezone),
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetAll]);

  const isRowSelectable = useMemo(() => {
    return (params) => {
      const node = params.level;
      const isGroupRow = node === 0;
      const isActive =
        params.data.active === true &&
        moment(new Date(params?.data?.dateFrom)).tz(user.timezone).format("YYYY-MM-DD HH:mm") >
        moment(new Date()).tz(user.timezone).format("YYYY-MM-DD HH:mm");
      if (isGroupRow) {
        params.selectable = isActive;
      }
      return isGroupRow && isActive;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTempRowData(data); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const scrollEvent = () => {
    const container = document.querySelector(".grid-container");
    if (Math.ceil(container.clientHeight + container.scrollTop) >= container.scrollHeight && nextToken) {
      dispatchAction({ type: "nextData" });
    }
  };

  const deleteEquipment = () => {
    setIsDialogOpen(true);
    setIsDropBooking(true);
  };

  useEffect(() => {
    localUserFilters.current = userFilters; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userFilters]);

  const sideBarDef = useMemo(() => {
    const columnsDef = {
      minWidth: 200,
      width: 276,
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "column-icon",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true,
        suppressColumnSelectAll: true,
      },
    };

    const filtersDef = {
      minWidth: 200,
      width: 276,
      id: "filters",
      labelDefault: "Filters",
      labelKey: "filters",
      iconKey: "filter",
      toolPanel: "agFiltersToolPanel",
    };

    const saveDef = {
      minWidth: 200,
      width: 276,
      id: "save_configuration",
      labelDefault: "Saved configurations",
      labelKey: "loading",
      iconKey: "setting-icon",
      toolPanel: () => {
        const savedChips =
          currentSideBarPanel === TOOL_PANELS.filters
            ? savedFilterChips.map(f => ({ ...f, chipName: f.chipName || f.filterName }))
            : savedColumnChips.map(c => ({ ...c, chipName: c.chipName || c.displayName }));


        const savedChip =
          currentSideBarPanel === TOOL_PANELS.filters
            ? { ...currentFilterChip }
            : { ...currentColumnsChip };

        const sideBars = gridRef?.current?.api?.getSideBar();
        const panels = sideBars
          ? sideBars.toolPanels?.map((p) => p.id)
          : [TOOL_PANELS.filters, TOOL_PANELS.saveConfiguration];

        return (
          <SaveConfiguration
            storeUser={user}
            savedChips={savedChips}
            savedChip={savedChip}
            currentSideBarPanel={currentSideBarPanel}
            gridRef={gridRef}
            onApplyColumns={onApplyColumnsFromChip}
            onApplyFilter={onApplyFilterFromChip}
            defaultShowColumns={defaultShowColumns}
            defaultFilterObj={DEFAULT_FILTER}
            sideBarPanels={[...panels]}
            user={user}
            onSave={onSave}
            onChipDelete={onChipDelete}
          />
        );
      },
    };

    const toolPanels =
      currentSideBarPanel === TOOL_PANELS.columns
        ? [columnsDef, saveDef]
        : [filtersDef, saveDef];

    return {
      toolPanels,
      defaultToolPanel: gridRef?.current?.api?.isSideBarVisible()
        ? gridRef?.current?.api?.getOpenedToolPanel() || currentSideBarPanel
        : currentSideBarPanel,
      hiddenByDefault: !showSideBar,
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSideBar, currentSideBarPanel, gridRef, savedFilterChips, savedColumnChips, currentFilterChip, currentColumnsChip, displayPreset, user, filterState?.currentFilter, onApplyColumnsFromChip, onApplyFilterFromChip,]);

  const attr = useMemo(() => ({
    height: "100%",
    columnDefs: tableColumn,
    animateRows: true,
    rowExport: false,
    sideBar: sideBarDef,
    allowContextMenuWithControlKey: true,
    getContextMenuItems: (params) => {
      return [
        'copy',
        'copyWithHeaders',
        'copyWithGroupHeaders',
        'separator',
        {
          name: 'Export',
          subMenu: [
            {
              name: 'Export Selected Rows',
              subMenu: [
                {
                  name: 'CSV Export',
                  action: () => {
                    const csvParams = {
                      ...params.api.gridOptionsService.get('defaultCsvExportParams'),
                      columnKeys: getExportableColumnKeys(tableColumn),
                    };
                    params.api.exportDataAsCsv(csvParams);
                  },
                },
                {
                  name: 'Excel Export',
                  action: () => {
                    const excelParams = {
                      ...params.api.gridOptionsService.get('defaultExcelExportParams'),
                      columnKeys: getExportableColumnKeys(tableColumn),
                    };
                    params.api.exportDataAsExcel(excelParams);
                  },
                },
              ],
            },
            'separator',
            {
              name: 'Export All (Filtered)',
              subMenu: [
                {
                  name: 'CSV Export',
                  action: () => {
                    const csvParams = {
                      ...params.api.gridOptionsService.get('defaultCsvExportParams'),
                      columnKeys: getExportableColumnKeys(tableColumn),
                      onlySelected: false,
                    };
                    params.api.exportDataAsCsv(csvParams);
                  },
                },
                {
                  name: 'Excel Export',
                  action: () => {
                    const excelParams = {
                      ...params.api.gridOptionsService.get('defaultExcelExportParams'),
                      columnKeys: getExportableColumnKeys(tableColumn),
                      onlySelected: false,
                    };
                    params.api.exportDataAsExcel(excelParams);
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    defaultCsvExportParams: createDefaultCsvExportParams({}, {}, user),
    defaultExcelExportParams: createDefaultExcelExportParams({}, {}, user),
    processCellForClipboard: createClipboardCellProcessor({}, user),
    defaultToolPanel: "filters",
    hiddenByDefault: true,
    rowData: tempRowData,
    icons: icons,
    onGridReady,
  }), [tableColumn, sideBarDef, tempRowData, icons, user, onGridReady]);

  return (
    <>
      <BackdropPortal show={fetching} />

      <div
        className="grid-container"
        onScroll={scrollEvent}
        style={{
          width: "100%",
          height: "100%",
          minHeight: "415px",
        }}
      >

        <DLabGrid
          {...attr}
          pagination={false}
          suppressPaginationPanel={false}
          defaultColDef={defaultColDef}
          rowSelection={"multiple"}
          suppressRowClickSelection={true}
          autoGroupColumnDef={"autoGroupColumnDef"}
          onRowSelected={onRowSelected}
          isRowSelectable={isRowSelectable}
          gridRef={gridRef}
          rowStyle={rowStyle}
          onFilterChanged={(params) => {
            if (params?.afterDataChange === false) {
              setEnableResetAll(true);
            }
            const filters = params.api.getFilterModel();
            if (Object.keys(filters).length > 0) {
              setDisableResetAll(false);
            }
          }}
        />
      </div>
      <BookingsPaginationActions
        selectedCount={selectedEquipment?.length}
        onCancelClick={() => setOpenMultiDeleteDialog(true)}
      />

    </>
  );
}

export default compose(
  connect(null, {
    loadPendingReservations: loadPendingReservationsAction,
  }),
  withApollo
)(EquipmentBookingList);
